export const SERVICES_RESPONSE = {
	CREATED: 'CREATED',
	UPDATED: 'UPDATED',
};
